import React from "react";
import { MdCheckCircle } from "react-icons/md";

interface StatusScreenProps {
  token: string | null;
  onNavigateBack: () => void;
}

export const LoadingScreen: React.FC = () => {
  return (
    <div className="flex h-screen items-center justify-center bg-gray-100 px-4">
      <div className="text-center">
        <div className="mb-4 h-10 w-10 md:h-12 md:w-12 animate-spin rounded-full border-4 border-gray-200 border-t-brand-500 mx-auto"></div>
        <p className="text-base md:text-lg font-semibold text-gray-700">Cargando cuestionario...</p>
      </div>
    </div>
  );
};

export const ErrorScreen: React.FC<StatusScreenProps & { errorMessage: string }> = ({ 
  errorMessage, 
  onNavigateBack 
}) => {
  return (
    <div className="flex h-screen items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md rounded-lg bg-white p-5 md:p-8 shadow-lg">
        <div className="mb-4 flex h-14 w-14 md:h-16 md:w-16 items-center justify-center rounded-full bg-red-100 mx-auto">
          <svg className="h-7 w-7 md:h-8 md:w-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h2 className="mb-3 md:mb-4 text-center text-xl md:text-2xl font-bold text-gray-800">Error</h2>
        <p className="text-center text-sm md:text-base text-gray-600">{errorMessage}</p>
        <div className="mt-5 md:mt-6 flex justify-center">
          <button
            onClick={onNavigateBack}
            className="rounded-lg bg-brand-500 px-4 py-2 text-sm md:text-base text-white hover:bg-brand-600"
          >
            Volver a la lista de cuestionarios
          </button>
        </div>
      </div>
    </div>
  );
};

export const SuccessScreen: React.FC = () => {
  return (
    <div className="flex h-screen items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md rounded-lg bg-white p-5 md:p-8 shadow-lg">
        <div className="mb-4 flex h-14 w-14 md:h-16 md:w-16 items-center justify-center rounded-full bg-green-100 mx-auto">
          <MdCheckCircle className="h-8 w-8 md:h-10 md:w-10 text-green-500" />
        </div>
        <h2 className="mb-3 md:mb-4 text-center text-xl md:text-2xl font-bold text-gray-800">¡Gracias!</h2>
        <p className="text-center text-sm md:text-base text-gray-600">Sus respuestas han sido enviadas correctamente.</p>
        <p className="mt-2 text-center text-xs md:text-sm text-gray-500">Redirigiendo a la lista de cuestionarios...</p>
      </div>
    </div>
  );
};

export const NotFoundScreen: React.FC<StatusScreenProps> = ({ onNavigateBack }) => {
  return (
    <div className="flex h-screen items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md rounded-lg bg-white p-5 md:p-8 shadow-lg">
        <h2 className="mb-3 md:mb-4 text-center text-xl md:text-2xl font-bold text-gray-800">Cuestionario no encontrado</h2>
        <p className="text-center text-sm md:text-base text-gray-600">No se pudo encontrar el cuestionario solicitado.</p>
        <div className="mt-5 md:mt-6 flex justify-center">
          <button
            onClick={onNavigateBack}
            className="rounded-lg bg-brand-500 px-4 py-2 text-sm md:text-base text-white hover:bg-brand-600"
          >
            Volver a la lista de cuestionarios
          </button>
        </div>
      </div>
    </div>
  );
}; 